import clsx from 'clsx';

import { Icon } from '@flintmint/web-shared/components/icon';
import { Button } from '@flintmint/web-shared/components/button';
import { Tooltip } from '@flintmint/web-shared/components/tooltip';
import { SaveAsConfirmation } from '@/components/save-as-confirmation';

import type { RenderAlert } from '@flintmint/web-shared/hooks/use-close-confirmation';

import styles from './inline-edit-actions.module.scss';

export const InlineEditActions = (props: InlineEditActionsProps) => {
  const {
    type,
    onSave,
    editing,
    onCancel,
    saveAsNew,
    processing,
    renderAlert,
    onSaveAsNew,
    noteVariant,
    documentName,
    onStartEditing,
    isAttachedToDoc,
    hasUnsavedChanges,
    isCloseConfirmationOpen,
    saveBlockedByReview,
  } = props;

  return editing ? (
    <div
      className={clsx(styles.inlineEditActions, {
        [styles.twoColumn]: saveAsNew,
        [styles.processing]: processing,
      })}
    >
      {hasUnsavedChanges && !isCloseConfirmationOpen ? (
        renderAlert(<Button color="grey">Cancel</Button>, false)
      ) : (
        <Button color="grey" onClick={onCancel} data-testid="plain-cancel-btn">
          Cancel
        </Button>
      )}
      <Tooltip content={saveBlockedByReview ? 'In order to save please accept or reject the AI generated content.' : ''}>
        <div className={styles.buttonGroupHolder}>
          <div
            className={clsx(styles.buttonGroup, {
              [styles.disabled]: saveBlockedByReview,
            })}
          >
            <button type="button" disabled={saveBlockedByReview} onClick={onSave}>
              Save
            </button>
            {saveAsNew && (
              <>
                <SaveAsConfirmation
                  type={type}
                  onSave={onSaveAsNew}
                  noteVariant={noteVariant}
                  documentName={documentName}
                  isAttachedToDoc={isAttachedToDoc}
                  disabled={saveBlockedByReview}
                />
                <div className={styles.indicator} />
              </>
            )}
          </div>
        </div>
      </Tooltip>
    </div>
  ) : (
    <Button icon={<Icon type="edit-02" size={24} />} color="light" disabled={processing} onClick={onStartEditing}>
      Edit
    </Button>
  );
};

interface InlineEditActionsProps {
  editing: boolean;
  onSave: () => void;
  saveAsNew?: boolean;
  noteVariant?: string;
  processing?: boolean;
  onCancel: () => void;
  documentName: string;
  isAttachedToDoc?: boolean;
  documentVariant?: string;
  saveBlockedByReview: boolean;
  renderAlert: RenderAlert;
  hasUnsavedChanges: boolean;
  onStartEditing?: () => void;
  type: 'userSources' | 'blocks';
  isCloseConfirmationOpen: boolean;
  onSaveAsNew: (documentName: string, replaceWithNew: boolean) => void;
}
